module.exports = __webpack_public_path__ + "img/tiefgaragendach.c9d9d5f8.jpg";